"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _wrapNativeSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(transactionSaga),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(handleFetchTransactionRequest),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(handleReplaceTransactionRequest),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(handleWatchPendingTransactions),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(handleWatchDroppedTransactions),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(handleWatchRevertedTransaction),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(handleConnectWalletSuccess);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FailedTransactionError = exports.transactionSaga = void 0;

var eth_1 = require("web3x/eth");

var effects_1 = require("redux-saga/effects");

var types_1 = require("./types");

var actions_1 = require("./actions");

var actions_2 = require("../wallet/actions");

var selectors_1 = require("./selectors");

var utils_1 = require("./utils");

var txUtils_1 = require("./txUtils");

var selectors_2 = require("../wallet/selectors");

var eth_2 = require("../../lib/eth");

function transactionSaga() {
  return _regeneratorRuntime.wrap(function transactionSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return effects_1.takeEvery(actions_1.FETCH_TRANSACTION_REQUEST, handleFetchTransactionRequest);

        case 2:
          _context.next = 4;
          return effects_1.takeEvery(actions_1.REPLACE_TRANSACTION_REQUEST, handleReplaceTransactionRequest);

        case 4:
          _context.next = 6;
          return effects_1.takeEvery(actions_1.WATCH_PENDING_TRANSACTIONS, handleWatchPendingTransactions);

        case 6:
          _context.next = 8;
          return effects_1.takeEvery(actions_1.WATCH_DROPPED_TRANSACTIONS, handleWatchDroppedTransactions);

        case 8:
          _context.next = 10;
          return effects_1.takeEvery(actions_1.WATCH_REVERTED_TRANSACTION, handleWatchRevertedTransaction);

        case 10:
          _context.next = 12;
          return effects_1.takeEvery(actions_2.CONNECT_WALLET_SUCCESS, handleConnectWalletSuccess);

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

exports.transactionSaga = transactionSaga;
var BLOCKS_DEPTH = 100;
var PENDING_TRANSACTION_THRESHOLD = 72 * 60 * 60 * 1000; // 72 hours

var REVERTED_TRANSACTION_THRESHOLD = 24 * 60 * 60 * 1000; // 24 hours

var TRANSACTION_FETCH_DELAY = 2 * 1000; // 2 seconds

var isExpired = function isExpired(transaction, threshold) {
  return Date.now() - transaction.timestamp > threshold;
};

var watchPendingIndex = {// hash: true
};
var watchDroppedIndex = {// hash: true
};

var FailedTransactionError = /*#__PURE__*/function (_Error) {
  _inherits(FailedTransactionError, _Error);

  function FailedTransactionError(hash, status) {
    var _this;

    _classCallCheck(this, FailedTransactionError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FailedTransactionError).call(this, "[".concat(hash, "] ").concat(status))); // 'Error' breaks prototype chain here

    _this.hash = hash;
    _this.status = status;
    Object.setPrototypeOf(_assertThisInitialized(_assertThisInitialized(_this)), (this instanceof FailedTransactionError ? this.constructor : void 0).prototype); // restore prototype chain

    return _this;
  }

  return FailedTransactionError;
}(_wrapNativeSuper(Error));

exports.FailedTransactionError = FailedTransactionError;

function handleFetchTransactionRequest(action) {
  var hash, transaction;
  return _regeneratorRuntime.wrap(function handleFetchTransactionRequest$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          hash = action.payload.hash;
          _context3.next = 3;
          return effects_1.select(function (state) {
            return selectors_1.getTransaction(state, hash);
          });

        case 3:
          transaction = _context3.sent;

          if (transaction) {
            _context3.next = 7;
            break;
          }

          console.warn("Could not find a valid transaction for hash ".concat(hash));
          return _context3.abrupt("return");

        case 7:
          _context3.prev = 7;
          return _context3.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var address, tx, isUnknown, txInState, nonceInState, nonceInNetwork, statusInState, statusInNetwork, nonce, isDropped, isReplaced;
            return _regeneratorRuntime.wrap(function _callee$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return effects_1.select(function (state) {
                      return selectors_2.getAddress(state);
                    });

                  case 2:
                    address = _context2.sent;
                    watchPendingIndex[hash] = true;
                    _context2.next = 6;
                    return effects_1.call(function () {
                      return txUtils_1.getTransaction(address, transaction.chainId, hash);
                    });

                  case 6:
                    tx = _context2.sent;
                    isUnknown = tx == null; // loop while tx is pending

                  case 8:
                    if (!(isUnknown || utils_1.isPending(tx.status) || tx.status === types_1.TransactionStatus.REPLACED // let replaced transactions be kept in the loop so it can be picked up as dropped
                    )) {
                      _context2.next = 37;
                      break;
                    }

                    _context2.next = 11;
                    return effects_1.select(function (state) {
                      return selectors_1.getTransaction(state, hash);
                    });

                  case 11:
                    txInState = _context2.sent;
                    // update nonce
                    nonceInState = txInState == null ? null : txInState.nonce;
                    nonceInNetwork = isUnknown ? null : tx.nonce;

                    if (!(nonceInNetwork != null && nonceInState == null)) {
                      _context2.next = 17;
                      break;
                    }

                    _context2.next = 17;
                    return effects_1.put(actions_1.updateTransactionNonce(hash, nonceInNetwork));

                  case 17:
                    // update status
                    statusInState = txInState == null ? null : txInState.status;
                    statusInNetwork = isUnknown ? null : tx.status;
                    nonce = nonceInState || nonceInNetwork;

                    if (!(statusInState !== statusInNetwork && nonce != null)) {
                      _context2.next = 29;
                      break;
                    }

                    // check if dropped or replaced
                    isDropped = statusInState != null && statusInNetwork == null;
                    isReplaced = statusInNetwork === types_1.TransactionStatus.REPLACED;

                    if (!(isDropped || isReplaced)) {
                      _context2.next = 27;
                      break;
                    }

                    _context2.next = 26;
                    return effects_1.put(actions_1.replaceTransactionRequest(hash, nonce));

                  case 26:
                    throw new FailedTransactionError(hash, types_1.TransactionStatus.DROPPED);

                  case 27:
                    _context2.next = 29;
                    return effects_1.put(actions_1.updateTransactionStatus(hash, statusInNetwork));

                  case 29:
                    _context2.next = 31;
                    return effects_1.delay(TRANSACTION_FETCH_DELAY);

                  case 31:
                    _context2.next = 33;
                    return effects_1.call(function () {
                      return txUtils_1.getTransaction(address, transaction.chainId, hash);
                    });

                  case 33:
                    tx = _context2.sent;
                    isUnknown = tx == null;
                    _context2.next = 8;
                    break;

                  case 37:
                    delete watchPendingIndex[hash];

                    if (!(tx.status === types_1.TransactionStatus.CONFIRMED)) {
                      _context2.next = 43;
                      break;
                    }

                    _context2.next = 41;
                    return effects_1.put(actions_1.fetchTransactionSuccess(Object.assign(Object.assign({}, transaction), {
                      status: tx.status,
                      receipt: {
                        logs: transaction.withReceipt ? tx.receipt.logs : []
                      }
                    })));

                  case 41:
                    _context2.next = 47;
                    break;

                  case 43:
                    if (!(tx.status === types_1.TransactionStatus.REVERTED)) {
                      _context2.next = 46;
                      break;
                    }

                    _context2.next = 46;
                    return effects_1.put(actions_1.watchRevertedTransaction(tx.hash));

                  case 46:
                    throw new FailedTransactionError(tx.hash, tx.status);

                  case 47:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee);
          })(), "t0", 9);

        case 9:
          _context3.next = 15;
          break;

        case 11:
          _context3.prev = 11;
          _context3.t1 = _context3["catch"](7);
          _context3.next = 15;
          return effects_1.put(actions_1.fetchTransactionFailure(_context3.t1.hash, _context3.t1.status, _context3.t1.message, transaction));

        case 15:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked2, null, [[7, 11]]);
}

function handleReplaceTransactionRequest(action) {
  var _action$payload, hash, nonce, transaction, provider, eth, accounts, account, checkpoint, tx, txInState, blockNumber, highestNonce, replacedBy, startBlock, endBlock, _loop, i, _ret, _txInState;

  return _regeneratorRuntime.wrap(function handleReplaceTransactionRequest$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _action$payload = action.payload, hash = _action$payload.hash, nonce = _action$payload.nonce;
          _context5.next = 3;
          return effects_1.select(function (state) {
            return selectors_1.getTransaction(state, hash);
          });

        case 3:
          transaction = _context5.sent;

          if (transaction) {
            _context5.next = 7;
            break;
          }

          console.warn("Could not find a valid transaction for hash ".concat(hash));
          return _context5.abrupt("return");

        case 7:
          _context5.next = 9;
          return effects_1.call(function () {
            return eth_2.getConnectedProvider();
          });

        case 9:
          provider = _context5.sent;

          if (provider) {
            _context5.next = 13;
            break;
          }

          console.warn('Could not connect to ethereum');
          return _context5.abrupt("return");

        case 13:
          eth = new eth_1.Eth(provider);
          _context5.next = 16;
          return effects_1.call(function () {
            return eth.getAccounts();
          });

        case 16:
          accounts = _context5.sent;

          if (!(accounts.length === 0)) {
            _context5.next = 20;
            break;
          }

          console.warn('Could not get accounts');
          return _context5.abrupt("return");

        case 20:
          account = accounts[0].toString();
          checkpoint = null;
          watchDroppedIndex[hash] = true;

        case 23:
          if (!true) {
            _context5.next = 72;
            break;
          }

          _context5.next = 26;
          return effects_1.call(function () {
            return txUtils_1.getTransaction(account, transaction.chainId, hash);
          });

        case 26:
          tx = _context5.sent;

          if (!(tx != null)) {
            _context5.next = 34;
            break;
          }

          _context5.next = 30;
          return effects_1.select(function (state) {
            return selectors_1.getTransaction(state, hash);
          });

        case 30:
          txInState = _context5.sent;
          _context5.next = 33;
          return effects_1.put(actions_1.fetchTransactionRequest(account, hash, utils_1.buildActionRef(txInState)));

        case 33:
          return _context5.abrupt("break", 72);

        case 34:
          _context5.next = 36;
          return effects_1.call(function () {
            return eth.getBlockNumber();
          });

        case 36:
          blockNumber = _context5.sent;
          highestNonce = 0;
          replacedBy = null; // loop through the last blocks

          startBlock = blockNumber;
          endBlock = checkpoint || blockNumber - BLOCKS_DEPTH;
          _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop(i) {
            var block, transactions;
            return _regeneratorRuntime.wrap(function _loop$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return effects_1.call(function () {
                      return eth.getBlock(i, true);
                    });

                  case 2:
                    block = _context4.sent;
                    transactions = block != null && block.transactions != null ? block.transactions : []; // look for a replacement tx, if so break the loop

                    replacedBy = transactions.find(function (tx) {
                      return tx.nonce === nonce && tx.from.toString() === account;
                    });

                    if (!replacedBy) {
                      _context4.next = 7;
                      break;
                    }

                    return _context4.abrupt("return", "break");

                  case 7:
                    // if no replacement is found, keep track of the highest nonce for the account
                    highestNonce = transactions.filter(function (tx) {
                      return tx.from.toString() === account;
                    }).reduce(function (max, tx) {
                      return Math.max(max, tx.nonce);
                    }, highestNonce);

                  case 8:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _loop);
          });
          i = startBlock;

        case 43:
          if (!(i > endBlock)) {
            _context5.next = 51;
            break;
          }

          return _context5.delegateYield(_loop(i), "t0", 45);

        case 45:
          _ret = _context5.t0;

          if (!(_ret === "break")) {
            _context5.next = 48;
            break;
          }

          return _context5.abrupt("break", 51);

        case 48:
          i--;
          _context5.next = 43;
          break;

        case 51:
          checkpoint = blockNumber; // if a replacement tx was found, replace it

          if (!replacedBy) {
            _context5.next = 64;
            break;
          }

          if (!(hash === replacedBy.hash)) {
            _context5.next = 61;
            break;
          }

          _context5.next = 56;
          return effects_1.select(function (state) {
            return selectors_1.getTransaction(state, hash);
          });

        case 56:
          _txInState = _context5.sent;
          _context5.next = 59;
          return effects_1.put(actions_1.fetchTransactionRequest(account, hash, utils_1.buildActionRef(_txInState)));

        case 59:
          _context5.next = 63;
          break;

        case 61:
          _context5.next = 63;
          return effects_1.put(actions_1.replaceTransactionSuccess(hash, replacedBy.hash));

        case 63:
          return _context5.abrupt("break", 72);

        case 64:
          if (!(highestNonce >= nonce)) {
            _context5.next = 68;
            break;
          }

          _context5.next = 67;
          return effects_1.put(actions_1.updateTransactionStatus(action.payload.hash, types_1.TransactionStatus.REPLACED));

        case 67:
          return _context5.abrupt("break", 72);

        case 68:
          _context5.next = 70;
          return effects_1.delay(TRANSACTION_FETCH_DELAY);

        case 70:
          _context5.next = 23;
          break;

        case 72:
          delete watchDroppedIndex[action.payload.hash];

        case 73:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked3);
}

function handleWatchPendingTransactions() {
  var transactions, pendingTransactions, _iterator, _step, tx;

  return _regeneratorRuntime.wrap(function handleWatchPendingTransactions$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return effects_1.select(selectors_1.getData);

        case 2:
          transactions = _context6.sent;
          pendingTransactions = transactions.filter(function (transaction) {
            return utils_1.isPending(transaction.status);
          });
          _iterator = _createForOfIteratorHelper(pendingTransactions);
          _context6.prev = 5;

          _iterator.s();

        case 7:
          if ((_step = _iterator.n()).done) {
            _context6.next = 19;
            break;
          }

          tx = _step.value;

          if (watchPendingIndex[tx.hash]) {
            _context6.next = 17;
            break;
          }

          if (isExpired(tx, PENDING_TRANSACTION_THRESHOLD)) {
            _context6.next = 15;
            break;
          }

          _context6.next = 13;
          return effects_1.fork(handleFetchTransactionRequest, actions_1.fetchTransactionRequest(tx.from, tx.hash, utils_1.buildActionRef(tx)));

        case 13:
          _context6.next = 17;
          break;

        case 15:
          _context6.next = 17;
          return effects_1.put(actions_1.updateTransactionStatus(tx.hash, types_1.TransactionStatus.DROPPED));

        case 17:
          _context6.next = 7;
          break;

        case 19:
          _context6.next = 24;
          break;

        case 21:
          _context6.prev = 21;
          _context6.t0 = _context6["catch"](5);

          _iterator.e(_context6.t0);

        case 24:
          _context6.prev = 24;

          _iterator.f();

          return _context6.finish(24);

        case 27:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked4, null, [[5, 21, 24, 27]]);
}

function handleWatchDroppedTransactions() {
  var transactions, droppedTransactions, _iterator2, _step2, tx;

  return _regeneratorRuntime.wrap(function handleWatchDroppedTransactions$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return effects_1.select(selectors_1.getData);

        case 2:
          transactions = _context7.sent;
          droppedTransactions = transactions.filter(function (transaction) {
            return transaction.status === types_1.TransactionStatus.DROPPED && transaction.nonce != null;
          });
          _iterator2 = _createForOfIteratorHelper(droppedTransactions);
          _context7.prev = 5;

          _iterator2.s();

        case 7:
          if ((_step2 = _iterator2.n()).done) {
            _context7.next = 14;
            break;
          }

          tx = _step2.value;

          if (watchDroppedIndex[tx.hash]) {
            _context7.next = 12;
            break;
          }

          _context7.next = 12;
          return effects_1.fork(handleReplaceTransactionRequest, actions_1.replaceTransactionRequest(tx.hash, tx.nonce));

        case 12:
          _context7.next = 7;
          break;

        case 14:
          _context7.next = 19;
          break;

        case 16:
          _context7.prev = 16;
          _context7.t0 = _context7["catch"](5);

          _iterator2.e(_context7.t0);

        case 19:
          _context7.prev = 19;

          _iterator2.f();

          return _context7.finish(19);

        case 22:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked5, null, [[5, 16, 19, 22]]);
}

function handleWatchRevertedTransaction(action) {
  var hash, txInState, address, txInNetwork;
  return _regeneratorRuntime.wrap(function handleWatchRevertedTransaction$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          hash = action.payload.hash;
          _context8.next = 3;
          return effects_1.select(function (state) {
            return selectors_1.getTransaction(state, hash);
          });

        case 3:
          txInState = _context8.sent;
          _context8.next = 6;
          return effects_1.select(function (state) {
            return selectors_2.getAddress(state);
          });

        case 6:
          address = _context8.sent;

        case 7:
          _context8.next = 9;
          return effects_1.delay(TRANSACTION_FETCH_DELAY);

        case 9:
          _context8.next = 11;
          return effects_1.call(function () {
            return txUtils_1.getTransaction(address, txInState.chainId, hash);
          });

        case 11:
          txInNetwork = _context8.sent;

          if (!(txInNetwork != null && txInNetwork.status === types_1.TransactionStatus.CONFIRMED)) {
            _context8.next = 18;
            break;
          }

          _context8.next = 15;
          return effects_1.put(actions_1.fixRevertedTransaction(hash));

        case 15:
          return _context8.abrupt("return");

        case 18:
          if (!(txInNetwork == null && txInState.nonce)) {
            _context8.next = 22;
            break;
          }

          _context8.next = 21;
          return effects_1.put(actions_1.replaceTransactionRequest(hash, txInState.nonce));

        case 21:
          return _context8.abrupt("return");

        case 22:
          if (!isExpired(txInState, REVERTED_TRANSACTION_THRESHOLD)) {
            _context8.next = 7;
            break;
          }

        case 23:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked6);
}

function handleConnectWalletSuccess(_) {
  var address, transactions, revertedTransactions, _iterator3, _step3, transaction;

  return _regeneratorRuntime.wrap(function handleConnectWalletSuccess$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return effects_1.put(actions_1.watchPendingTransactions());

        case 2:
          _context9.next = 4;
          return effects_1.put(actions_1.watchDroppedTransactions());

        case 4:
          _context9.next = 6;
          return effects_1.select(function (state) {
            return selectors_2.getAddress(state);
          });

        case 6:
          address = _context9.sent;
          _context9.next = 9;
          return effects_1.select(function (state) {
            return selectors_1.getTransactions(state, address);
          });

        case 9:
          transactions = _context9.sent;
          revertedTransactions = transactions.filter(function (transaction) {
            return transaction.status === types_1.TransactionStatus.REVERTED && !isExpired(transaction, REVERTED_TRANSACTION_THRESHOLD);
          });
          _iterator3 = _createForOfIteratorHelper(revertedTransactions);
          _context9.prev = 12;

          _iterator3.s();

        case 14:
          if ((_step3 = _iterator3.n()).done) {
            _context9.next = 20;
            break;
          }

          transaction = _step3.value;
          _context9.next = 18;
          return effects_1.put(actions_1.watchRevertedTransaction(transaction.hash));

        case 18:
          _context9.next = 14;
          break;

        case 20:
          _context9.next = 25;
          break;

        case 22:
          _context9.prev = 22;
          _context9.t0 = _context9["catch"](12);

          _iterator3.e(_context9.t0);

        case 25:
          _context9.prev = 25;

          _iterator3.f();

          return _context9.finish(25);

        case 28:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked7, null, [[12, 22, 25, 28]]);
}